<template>
	<div class="app-wrapper">
		<div id="app" class="app">
			<header :class="{'o-v-rhythm' : $route.name !== 'eoi' && $route.name !== 'thank-you'}">
				<network-navigation />
				<page-heading />
			</header>

			<main class="app-content" :class="{'eoi-bg' : $route.name === 'eoi', 'eoi-bg eoi-bg__thankyou': $route.name === 'thank-you'}">
				<div class="o-container o-container--thin" v-if="isLoading">
					<preloader-view class="o-v-rhythm--small" />
				</div>
				<router-view class="o-v-rhythm" v-else />
			</main>

			<footer>
				<network-footer />
			</footer>
		</div>
	</div>
</template>

<script>
	import PreloaderView from './components/views/PreloaderView.vue';
	import NetworkNavigation from './components/headers/NetworkNavigation.vue';
	import PageHeading from './components/headers/PageHeading.vue';
	import NetworkFooter from './components/footers/NetworkFooter.vue';
	import { mapState } from 'vuex';

	export default {
		name: 'app',
		components: {
			PreloaderView,
			NetworkNavigation,
			PageHeading,
			NetworkFooter
		},
		computed: {
			...mapState(['isLoading'])
		}
	}
</script>

<style scoped lang="scss">
	.app-wrapper {
		display: flex;
		flex-direction: column;
	}

	.app {
		display: flex;
		min-height: 100vh;
		flex-direction: column;
		flex: 1;
	}

	.app-content {
		flex: 1 0 auto;
	}

  .eoi-bg {
    background-image: url('../img/eoi/eoi_background_img.jpg');
    background-size: cover;
    background-position: center;

    &__thankyou {
      background-position-y: 50%;
    }
  }
</style>